export default import.meta.ROLLUP_FILE_URL_m2DusX4GZeOnqOIx4RBRJA